/* フッターエリア */
import React from 'react';
var FooterButtonShelf = function () {
    return (React.createElement("div", { className: "footer-button-group mx-auto px-0 col-11 col-xs-10 col-lg-9" }));
};
export default FooterButtonShelf;
